import React from "react";
import { Spin } from "antd";

// Styles
import { Wrapper } from "./styles";

//All page loading spin
const Loading = () => {
  return (
    <Wrapper>
      <Spin />
    </Wrapper>
  );
};

export default Loading;
